export const DEFAULT_TOTAL_RECORDS = 10;
export const STALE_TIME = 5000;
export const DROPDOWN_STALE_TIME = 10 * 60 * 60 * 1000; //10hr
export const ALERT_TIMEOUT = 4000;
export const DETAIL_ALERT_TIMEOUT = 10000;
export const QUERY_DISBALED_KEY = "__DONT_HIT_API__";
export const MODALS = {
  ADD_FOOTER_HEADER_IMAGE_MODAL: "add_footer_header_image_modal",
  ADD_SETTLEMENT_MODAL: "add_settlement_modal",
  UPLOADSIGNATURE: "upload_signature",
  SHOWSIGNATURE: "show_signature",
  ADD_MODAL: "add_modal",
  DELETE_MODAL: "delete_modal",
  ADD_ZONE_MODAL: "add_zone_modal",
  COPY_ZONE_OBSERVATIONS_MODAL: "copy_zone_observations_modal",
  DELETE_ZONE_MODAL: "delete_zone_modal",
  ADD_BRANCH_MODAL: "add_branch_modal",
  DELETE_BRANCH_MODAL: "delete_branch_modal",
  ADD_DEPARTMENT_MODAL: "add_department_modal",
  DELETE_DEPARTMENT_MODAL: "delete_department_modal",
  ADD_DESIGNATION_MODAL: "add_designation_modal",
  DELETE_DESIGNATION_MODAL: "delete_designation_modal",
  ADD_EMPLOYEES_MODAL: "add_employees_modal",
  DELETE_EMPLOYEES_MODAL: "delete_employees_modal",
  ADD_EMPLOYEE_TYPE_MODAL: "add_employee_type_modal",
  DELETE_EMPLOYEE_TYPE_MODAL: "delete_employee_type_modal",
  // ADD_EMPLOYEE_CATEGORY_MODAL: "add_employee_category_modal",
  DELETE_EMPLOYEE_CATEGORY_MODAL: "delete_employee_category_modal",
  ADD_DISCOUNT_REASON_MODAL: "add_discount_reason_modal",
  DELETE_DISCOUNT_REASON_MODAL: "delete_discount_reason_modal",
  ADD_PAYMENT_MODE_MODAL: "add_payment_mode_modal",
  DELETE_PAYMENT_MODE_MODAL: "delete_payment_mode_modal",
  ADD_ROLE_MODAL: "add_role_modal",
  DELETE_ROLE_MODAL: "delete_role_modal",
  ADD_ROLE_SECTIONS_MODAL: "add_role_sections_modal",
  VIEW_ROLE_SECTIONS_MODAL: "view_role_sections_modal",
  ADD_SECTION_MODAL: "add_section_modal",
  DELETE_SECTION_MODAL: "delete_section_modal",
  ADD_DOCUMENT_MODAL: "add_document_modal",
  DELETE_DOCUMENT_MODAL: "delete_document_modal",
  ADD_SHARE_TYPE_MODAL: "add_share_type_modal",
  DELETE_SHARE_TYPE_MODAL: "delete_share_type_modal",
  ADD_SAMPLE_TYPE_MODAL: "add_sample_type_modal",
  DELETE_SAMPLE_TYPE_MODAL: "delete_sample_type_modal",
  ADD_SAMPLE_REJECTION_REASON_MODAL: "add_sample_rejection_reason_modal",
  DELETE_SAMPLE_REJECTION_REASON_MODAL: "delete_sample_rejection_reason_modal",
  ADD_PAYMENT_TYPE_MODAL: "add_payment_type_modal",
  DELETE_PAYMENT_TYPE_MODAL: "delete_payment_type_modal",
  ADD_INVESTIGATION_TEST_MODAL: "add_investigation_test_modal",
  ADD_INVESTIGATION_MANAGER_MODAL: "add_investigation_manager_modal",
  DELETE_INVESTIGATION_TEST_MODAL: "delete_investigation_test_modal",
  ADD_INVESTIGATION_TEMPLATE_MODAL: "add_investigation_template_modal",
  DELETE_INVESTIGATION_TEMPLATE_MODAL: "delete_investigation_template_modal",
  ADD_EMP_DISCOUNT_ALLOWED_MODAL: "add_emp_discount_allowed_modal",
  DELETE_EMP_DISCOUNT_ALLOWED_MODAL: "delete_emp_discount_allowed_modal",
  ADD_INVESTIGATION_NABL_MODAL: "add_investigation_nabl_modal",
  DELETE_INVESTIGATION_NABL_MODAL: "delete_investigation_nabl_modal",
  ADD_OUTSOURCE_INVESTIGATION_MODAL: "add_outsource_investigation_modal",
  DELETE_OUTSOURCE_INVESTIGATION_MODAL: "delete_outsource_investigation_modal",
  ADD_OUTSOURCE_LAB_MODAL: "add_outsource_lab_modal",
  DELETE_OUTSOURCE_LAB_MODAL: "delete_outsource_lab_modal",
  ADD_PACKAGE_MODAL: "add_package_modal",
  ADD_PACKAGE_COSTS_MODAL: "add_package_cost_modal",
  DELETE_PACKAGE_MODAL: "delete_package_modal",
  ADD_TEST_RATE_MODAL: "add_test_rate_modal",
  DELETE_TEST_RATE_MODAL: "delete_test_rate_modal",
  ADD_INVESTIGATION_HELP_MODAL: "add_investigation_help_modal",
  DELETE_INVESTIGATION_HELP_MODAL: "delete_investigation_help_modal",
  ADD_INTERPRETATION_MODAL: "add_interpretation_modal",
  DELETE_INTERPRETATION_MODAL: "delete_interpretation_modal",
  ADD_DELIVERY_DAYS_MODAL: "add_delivery_days_modal",
  DELETE_DELIVERY_DAYS_MODAL: "delete_delivery_days_modal",
  ADD_INVESTIGATION_COMMENT_MODAL: "add_investigation_comment_modal",
  DELETE_INVESTIGATION_COMMENT_MODAL: "delete_investigation_comment_modal",
  ADD_INVESTIGATION_DETAILS_MODAL: "add_investigation_details_modal",
  DELETE_INVESTIGATION_DETAILS_MODAL: "delete_investigation_details_modal",
  ADD_DOCTOR_MODAL: "add_doctor_modal",
  DELETE_DOCTOR_MODAL: "delete_doctor_modal",
  ADD_FRANCHISE_DETAILS_MODAL:
    "aadd_investigation_package_modaldd_franchise_details_modal",
  DELETE_FRANCHISE_DETAILS_MODAL: "delete_franchise_details_modal",
  ADD_PATIENT_MODAL: "add_patient_modal",
  DELETE_PATIENT_MODAL: "delete_patient_modal",
  ADD_INVESTIGATION_PACKAGE_MASTER_MODAL:
    "add_investigation_package_master_modal",
  DELETE_INVESTIGATION_PACKAGE_MASTER_MODAL:
    "delete_investigation_package_master_modal",
  ADD_INVESTIGATION_PACKAGE_MODAL: "add_investigation_package_modal",
  DELETE_INVESTIGATION_PACKAGE_MODAL: "delete_investigation_package_modal",
  ADD_INVESTIGATION_LIST: "add_investigation_list",
  ADD_PATIENT_APPOINTMENT_DETAILS: "add_patient_appointment_details",
  DELETE_PATIENT_APPOINTMENT_DETAILS: "delete_patient_appointment_details",
  ADD_OBSERVATION_MASTER_MODAL: "add_observation_master_modal",
  INVESTIGATION_OBSERVATION_EDIT_MODAL: "investigation_observation_edit_modal",
  INTERNAL_OBSERVATION_EDIT_MODAL: "internal_observation_edit_modal",
  ADD_FRANCHISE_MODAL: "add_franchise_modal",
  ADD_ROLES_MODAL: "add_roles_modal",
  ADD_SAMPLE_MODAL: "add_sample_type",
  ADD_EMPLOYEE_CATEGORY_MODAL: "add_employee_category_modal",
  ADD_COPY_RATES: "add_copy_rates",
  ADD_RECEIVED_PAYMENT: "add_received_payment",
  LIST_PAYMENT: "list_payment",
  PENDING_PAYMENT_LIST: "pending_payment_list",
  ADD_OBSERVATION_RANGE_MASTER_MODAL: "add_observation_range_master_modal",
  ADD_FRANCHISE_ADVANCE_PAYMENT_MODAL: "add_franchise_advance_payment_modal",
  DELETE_FRANCHISE_ADVANCE_PAYMENT_MODAL:
    "delete_franchise_advance_payment_modal",
  ADD_OBSERVATION_RESULT_ENTRY_MODAL: "add_observation_result_entry_modal",
  ADD_COMMISSION_MODAL: "add_commission_modal",
  DELETE_COMMISSION_MODAL: "delete_commission_modal",
  DELETE_EMPLOYEE_ROLE_MODAL: "delete_employee_role_modal",
  ADD_MACHINE_MASTER_MODAL: "add_machine_master_modal",
  ADD_OBSERVATION_HOST_CODE_MODAL: "add_observation_host_code_modal",
  ADD_APPOINMENT_PAYMENT_MODAL: "add_appoinment_payment_modal",
  ADD_REPORT_ROLES_MODAL: "add_report_roles_modal",
  ADD_ASSIGN_ROLES_MODAL: "add_Assign_roles_modal",
  DELETE_ASSIGN_ROLES_MODAL: "delete_Assign_roles_modal",
  ADD_RECEIVED_PAYMENT_MODAL: "add_received_payment_modal",
  DELETE_RECEIVED_PAYMENT_MODAL: "delete_received_payment_modal",
  CHANGE_FRANCHISE_MODAL: "change_franchise_modal",
  CHANGE_BARCODE_MODAL: "change_barcode_modal",
  CHANGE_ZONE_MODAL: "change_zone_modal",
  ALLOCATE_ZONE_MODAL: "allocate_zone_modal",
  DELETE_ONLINE_PAYMENT_DETAIL_MODAL: "delete_online_payment_detail_modal",
  ADD_VENDOR_MODAL: "add_vendor_modal",
  DELETE_VENDOR_MODAL: "delete_vendor_modal",
  ADD_PRODUCT_MODAL: "add_product_modal",
  DELETE_PRODUCT_MODAL: "delete_product_modal",
  ADD_TERMS_CONDITION_MODAL: "add_terms_condition_modal",
  DELETE_TERMS_CONDITION_MODAL: "delete_terms_condition_modal",
  ADD_PURCHASE_ORDER_MODAL: "add_purchase_order_modal",
  DELETE_PURCHASE_ORDER_MODAL: "delete_purchase_order_modal",
  ADD_STOCKIN_MODAL: "add_stockin_modal",
  DELETE_STOCKIN_MODAL: "delete_stockin_modal",
  ADD_STOCKOUT_MODAL: "add_stockout_modal",
  DELETE_STOCKOUT_MODAL: "delete_stockout_modal",
  ADD_EMPLOYEE_LEAVE_MODAL: "add_employee_leave_modal",
  DELETE_EMPLOYEE_LEAVE_MODAL: "delete_employee_leave_modal",
  ADD_EMPLOYEE_LEAVE_HISTORY_MODAL: "add_employee_leave_history_modal",
  ADD_COMMISSION_LEDGER_HISTORY_MODAL: "add_commission_ledger_history_modal",
  ADD_PAYMENT_LEDGER_HISTORY_MODAL: "add_payment_ledger_history_modal",
  ADD_CREDIT_TRANSFER_MODAL: "add_credit_transfer_modal",
  DELETE_CREDIT_TRANSFER_MODAL: "delete_credit_transfer_modal",
  ADD_INVESTIGATION_OBSERVATION_FORMULA_MODAL:
    "add_investigation_observation_formula_modal",
  ADD_PENDING_OBSERVATIONS_MODAL: "add_pending_observations_modal",
  CHANGE_BARCODE_PATIENT_APPOINTMENT_DETAIL_MODAL:
    "change_barcode_patient_appointment_detail_modal",
  VIEW_ROLES: "view_roles",
  EDIT_BARCODE: "edit_barcode",
  UPLOAD_DOCUMENT_MODAL: "upload_document_modal",
  PATIENT_DOCUMENT_MODAL: "patient_document_modal",
};

export const FILTER_TYPE = {
  SELECT: "SELECT",
  MULTI_SELECT: "MULTI_SELECT",
  DATE_RANGE_DROPDOWN: "DATE_RANGE_DROPDOWN",
  TEXT: "TEXT",
  SWITCH: "SWITCH",
  NUMBER: "NUMBER",
};

export const observationRangeEmptyForm = {
  ranges: [
    {
      gender: "",
      from_age: "",
      to_age: "",
      min_reading: "",
      max_reading: "",
      min_critical: "",
      max_critical: "",
      display_reading: "",
      default_reading: "",
      abnormal_reading: "",
      unit: "",
      isAddedNew: true,
    },
  ],
};
